/*
 *   File : order-timeline.js
 *   Author : https://evoqins.com
 *   Description : Order timeline modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React from 'react';

//Custom components
import { Icon } from '../Icon';

const TIMELINE_DATA = [
    {
        label: "Order initiated",
        date: "23 Sep 2024"
    },
    {
        label: "Payment initiated from Federal Bank",
        date: "23 Sep 2024"
    },
    {
        label: "Order accepted",
        date: "23 Sep 2024"
    },
    {
        label: "Units allocated",
        date: "23 Sep 2024"
    },
];

const OrderTimelineModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("timeline-modal-close");
        button.click();
        props.handleClose();
    };

    return (
        <div className="modal fade"
            id="timeline-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="timelineModalLabel"
            aria-hidden="true">

            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28">
                <span id='timeline-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            View order timeline
                        </h6>

                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 padding-32px-lr padding-32px-bottom'>
                        <div className='e-bg-magnolia py-4 px-3 border-radius-8 e-border-1px-pale-lavender-extra-light'>
                            {props.timelineData.timeline.map((data, key) => (
                                <div className='d-flex gap-2 align-items-start'>
                                    <div className='d-flex flex-column  align-items-center'>
                                        <div>
                                            <Icon icon={data.status === "SUCCESS" ? "success" : data.status === "PENDING" ? "pending" : data.status === "FAILED" ? "failed" : null}
                                                size="1.25rem"
                                                className="d-flex" />
                                        </div>
                                        {props.timelineData.timeline.length - 1 !== key &&
                                            <div className='d-flex'>
                                                <div className={`vr  h-56px w-1px ${data.status === "SUCCESS" ? "e-bg-aero-blue" : data.status === "PENDING" ? "e-bg-light-beige" : data.status === "FAILED" ? "e-bg-pale-pink" : null} `}></div>
                                            </div>
                                        }
                                    </div>
                                    <div>
                                        <p className='margin-2px-bottom e-text-davys-grey-light e-primary-font e-font-14 e-font-weight-400 line-height-22px'>
                                            {data.label}
                                        </p>
                                        <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-400 line-height-22px'>
                                            {data.value}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrderTimelineModal;

OrderTimelineModal.defaultProps = {
    handleClose: () => { },
    className: null,
};